/**
 * Frontend error tracking - optional Sentry integration.
 * When VITE_SENTRY_DSN is set and @sentry/react is installed, reports errors to Sentry.
 * Otherwise, captureException is a no-op (errors still logged in dev).
 *
 * To enable: npm install @sentry/react && set VITE_SENTRY_DSN in .env
 */

import { initGA } from './analytics'

let captureImpl = null

/**
 * Initialize error tracking (call from main.jsx).
 * Dynamically loads Sentry when VITE_SENTRY_DSN is set.
 */
export async function initErrorTracking() {
  // Initialize GA4
  initGA()

  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn || typeof dsn !== 'string' || !dsn.trim()) return

  try {
    const Sentry = await import('@sentry/react')
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE || 'development',
    })
    captureImpl = (err, ctx) => Sentry.captureException(err, { extra: ctx })
  } catch (e) {
    if (import.meta.env.DEV) console.warn('Sentry init failed (install @sentry/react to enable):', e.message)
  }
}

/**
 * Report an exception to the tracking service (no-op if not configured).
 */
export function captureException(error, context = {}) {
  if (captureImpl) captureImpl(error, context)
}
